module.exports = __webpack_public_path__ + "static/media/Delete-page.0aa26593.svg";